export default __webpack_public_path__ + "static/media/banner-duc-thanh-wood.1711f5af.jpg";